import { mapgisSeg } from "./mapgisSeg";

export default async function consultarInfoToken() {
  let responseDecodeJwt = { idUsuario: 0, identificador: "" };
  try {
    const responseToken = await mapgisSeg("validacionToken.do", {
      app: process.env.REACT_APP_ID_APP,
    });
    if (responseToken !== "Sin autenticacion") {
      let response = await mapgisSeg("validarToken.do", {
        token: responseToken,
      });
      responseDecodeJwt = {
        idUsuario: response.idUsuario,
        identificador: response.identificador,
      };
    }
  } catch (error) {
    console.error(error);
  }

  return responseDecodeJwt;
}
